// extracted by mini-css-extract-plugin
export var lbContainerOuter = "G_wh";
export var lbContainerInner = "G_wj";
export var movingForwards = "G_wk";
export var movingForwardsOther = "G_wl";
export var movingBackwards = "G_wm";
export var movingBackwardsOther = "G_wn";
export var lbImage = "G_wp";
export var lbOtherImage = "G_wq";
export var prevButton = "G_wr";
export var nextButton = "G_ws";
export var closing = "G_wt";
export var appear = "G_wv";